module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.7ec5dab7.woff2";